import {
  t,
  translate,
} from "components/CentralDataMangement/translation/Translation";
import Title from "components/common/atoms/Title";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import React from "react";
import { Link } from "react-router-dom";
import { LLM_LATEST_SLUG_SELECTOR, MANAGE_LLM_MODELS, MANAGE_LLM_PROMPTS, MANAGE_LLM_PROVIDERS } from "routes/RouteConstants";

const ContentCreation: React.FC = () => {
  const cardStyle = {
    className:
      "card border-0 card-shadow justify-content-center h-100",
  };

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Content creation",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <>
        <Title
          title={t("Content creation")}
          className="tab-section-title "
        />
        <div className="form-height-dashboard mt-2">
          <div
            className="recruiter-action-tabs"
            style={{
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "1.5vw",
              display: "grid",
            }}
          >

            <Link to={MANAGE_LLM_PROVIDERS} className="dashboard-tab-links">
              <div {...cardStyle}>{t("LLM providers")}</div>
            </Link>

            <Link to={MANAGE_LLM_MODELS} className="dashboard-tab-links">
              <div {...cardStyle}>{t("LLM models")}</div>
            </Link>

            <Link to={MANAGE_LLM_PROMPTS} className="dashboard-tab-links">
              <div {...cardStyle}>{t("LLM prompts")}</div>
            </Link>

            <Link to={LLM_LATEST_SLUG_SELECTOR} className="dashboard-tab-links">
              <div {...cardStyle}>{t("Latest slugs")}</div>
            </Link>

          </div>
        </div>
        <div className="row backPadding">
          <div className="col-md-6 align-self-center">
            <Link to="/dashboard" className="back-btn text-decoration-underline">
              {t("Back")}
            </Link>
          </div>
        </div>
      </>
    </AccessControl>
  );
};

export default translate(ContentCreation);
